/*
  BAIC Vaal — lead context
  ---------------------------------------------------------------
  One small store for everything a visitor tells the site before
  they reach a form: the colour they picked in the 360, their
  "Which BAIC suits you?" answers and the models saved to My garage.
  Every enquiry form reads it (sections/contactform.liquid), so the
  sales team gets the context without the visitor retyping it.

  Loaded synchronously in <head> (it is tiny) so inline section
  scripts can call window.BAICLead straight away.

  Storage is localStorage with an in-memory fallback — private
  windows and blocked storage just lose persistence, nothing breaks.
  Changes fire a `baic:lead` event on document, and other tabs are
  kept in step through the `storage` event.
*/
(function () {
  if (window.BAICLead) return;

  var KEY = 'baic_lead_v1';
  var memory = {};

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) || {} : memory;
    } catch (e) {
      return memory;
    }
  }

  function write(state) {
    memory = state;
    try { window.localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
  }

  function emit(state) {
    var evt;
    try {
      evt = new CustomEvent('baic:lead', { detail: state });
    } catch (e) {
      evt = document.createEvent('CustomEvent');
      evt.initCustomEvent('baic:lead', false, false, state);
    }
    document.dispatchEvent(evt);
  }

  function norm(s) {
    return String(s || '').toLowerCase().replace(/^baic\s+/, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  var api = {
    get: function () { return read(); },

    set: function (patch) {
      var state = read();
      for (var k in patch) {
        if (Object.prototype.hasOwnProperty.call(patch, k)) {
          if (patch[k] === null) delete state[k];
          else state[k] = patch[k];
        }
      }
      state.updated = Date.now();
      write(state);
      emit(state);
      return state;
    },

    clear: function (keys) {
      var patch = {};
      (keys || ['colour', 'colourModel', 'colourHex', 'quiz', 'garage']).forEach(function (k) { patch[k] = null; });
      return api.set(patch);
    },

    /* Loose model match: "BAIC B30" == "B30", "B40 Plus" ~ "B40 Plus Honor Edition". */
    sameModel: function (a, b) {
      var x = norm(a), y = norm(b);
      if (!x || !y) return false;
      return x === y || x.indexOf(y) === 0 || y.indexOf(x) === 0;
    },

    garage: {
      list: function () { return read().garage || []; },
      has: function (name) {
        return api.garage.list().some(function (m) { return api.sameModel(m.name, name); });
      },
      add: function (model) {
        if (!model || !model.name || api.garage.has(model.name)) return;
        var list = api.garage.list().slice();
        list.push({ name: model.name, url: model.url || '', image: model.image || '', price: model.price || '' });
        api.set({ garage: list.slice(-6) });
      },
      remove: function (name) {
        api.set({ garage: api.garage.list().filter(function (m) { return !api.sameModel(m.name, name); }) });
      },
      toggle: function (model) {
        if (api.garage.has(model.name)) api.garage.remove(model.name);
        else api.garage.add(model);
        return api.garage.has(model.name);
      }
    },

    on: function (fn) {
      document.addEventListener('baic:lead', function (e) { fn(e.detail || read()); });
    }
  };

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) emit(read());
  });

  /* Save-to-garage buttons (snippets/baic-garage-toggle.liquid) anywhere on
     the page, including ones injected later — one delegated listener. */
  function syncToggles() {
    var buttons = document.querySelectorAll('[data-baic-garage-toggle]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var on = api.garage.has(btn.getAttribute('data-name'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-saved', on);
      var label = btn.querySelector('[data-baic-garage-label]');
      if (label) label.textContent = on ? (btn.getAttribute('data-saved-label') || 'Saved') : (btn.getAttribute('data-save-label') || 'Save');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-baic-garage-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    api.garage.toggle({
      name: btn.getAttribute('data-name'),
      url: btn.getAttribute('data-url'),
      image: btn.getAttribute('data-image'),
      price: btn.getAttribute('data-price')
    });
  });

  api.on(syncToggles);
  api.syncToggles = syncToggles;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncToggles);
  else syncToggles();

  window.BAICLead = api;
})();
